import React, { useState } from "react";
import { TextField, Button, Container, Typography, Box } from "@mui/material";
import styled from "styled-components";
import API from "../../../utils/api";
// import MenuItem from "@mui/material/MenuItem";

const TestContainer = styled(Container)`
  background-color: #1b1a2ea9;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0px 10px 10px 0px rgba(9, 5, 29, 0.171);
  backdrop-filter: blur(15px);
  color: white;
`;

const StyledTextField = styled(TextField)`
  & .MuiInputBase-root {
    color: white;
  }
  & .MuiInputLabel-root {
    color: white;
  }
  & .MuiOutlinedInput-root {
    & fieldset {
      border-color: white;
    }
    &:hover fieldset {
      border-color: #c770f0;
    }
    &.Mui-focused fieldset {
      border-color: #c770f0;
    }
  }
  margin-bottom: 1rem;
`;

const StyledButton = styled(Button)`
  background-color: #623686;
  color: white;
  margin-left: 1rem;
  margin-right: 1rem;
  &:hover {
    background-color: #6d20c5d7;
  }
`;

const TestForm = () => {
  const [questions, setQuestions] = useState({
    json_str: "",
    description: "",
    date: "",
    category: "",
  });

  // const categories = [
  //   {
  //     value: "mcq",
  //     label: "MCQ",
  //   },
  //   {
  //     value: "scenario",
  //     label: "Scenario Based",
  //   },
  //   {
  //     value: "qa",
  //     label: "Question Answer",
  //   },
  //   {
  //     value: "coding",
  //     label: "Coding",
  //   },
  //   {
  //     value: "fill_in_blank",
  //     label: "Fill In Blank",
  //   },
  //   {
  //     value: "case_study",
  //     label: "Case Study",
  //   },
  //   {
  //     value: "matching",
  //     label: "Matching",
  //   },
  //   {
  //     value: "true_false",
  //     label: "True or False",
  //   },
  // ];
  const handleChange = (e) => {
    setQuestions({ ...questions, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // const currentDate = new Date();
    // const year = currentDate.getFullYear();
    // const month = (currentDate.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-based, so add 1
    // const day = currentDate.getDate().toString().padStart(2, "0");

    // const formattedDate = `${year}-${month}-${day}`;
    // console.log(currentDate);

    try {
      setQuestions({ ...questions, json_str: JSON.parse(questions.json_str) });
      await API.post("/api/learning/addQuestions", {
        ...questions,
        // date: currentDate,
        // str_date: formattedDate,
      })
        .then((res) => res.data)
        .then((res) => {
          setQuestions({
            description: "",
            json_str: "",
            category: "",
          });
          alert(res.message);
        })
        .catch((error) => {
          alert("Error submitting Learning", error);
        });
    } catch (error) {
      console.error(error);
      alert("Syntax Error!");
    }
  };
  return (
    <Container fluid className="resume-section">
      <TestContainer maxWidth="md">
        <Typography variant="h4" gutterBottom className="purple">
          Add Test
        </Typography>
        <form onSubmit={handleSubmit}>
          <StyledTextField
            size="small"
            fullWidth
            variant="outlined"
            label="Json"
            name="json_str"
            multiline
            minRows={20}
            maxRows={20}
            value={questions.json_str}
            onChange={handleChange}
            type="text"
            required
          />
          <Box mt={2}>
            <StyledButton variant="contained" type="submit">
              Submit
            </StyledButton>
          </Box>
        </form>
      </TestContainer>
    </Container>
  );
};

export default TestForm;
